var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSamlError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#cce5ff;}.cls-3{fill:#2171b5;}.cls-4{fill:#f7e7e7;}.cls-5{fill:#de5656;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,9.79A14.59,14.59,0,0,0,23.42,24.36V39.93a14.58,14.58,0,0,0,29.15,0V24.36A14.59,14.59,0,0,0,38,9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,2A22.38,22.38,0,0,0,13.64,24.36V39.93a22.36,22.36,0,0,0,44.72,0V24.36A22.38,22.38,0,0,0,36,2ZM52.57,39.93a16.57,16.57,0,1,1-33.14,0V24.36a16.57,16.57,0,0,1,33.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38,0A24.39,24.39,0,0,0,13.63,24.36V39.93a24.36,24.36,0,0,0,48.72,0V24.36A24.39,24.39,0,0,0,38,0ZM60.35,39.93a22.36,22.36,0,0,1-44.72,0V24.36a22.36,22.36,0,0,1,44.72,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38,7.79A16.59,16.59,0,0,0,21.42,24.36V39.93a16.58,16.58,0,0,0,33.15,0V24.36A16.59,16.59,0,0,0,38,7.79ZM52.57,39.93a14.58,14.58,0,0,1-29.15,0V24.36a14.58,14.58,0,0,1,29.15,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 33.61,
    width: 72,
    height: 57.74,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68,31.61H8a8,8,0,0,0-8,8V85.35a8,8,0,0,0,8,8H68a8,8,0,0,0,8-8V39.61A8,8,0,0,0,68,31.61Zm6,53.74a6,6,0,0,1-6,6H8a6,6,0,0,1-6-6V39.61a6,6,0,0,1,6-6H68a6,6,0,0,1,6,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.07,
    y: 69.83,
    width: 6.3,
    height: 9.97,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.37,71.83a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1h-.3a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h.3m0-2h-.3a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h.3a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 74,
    cy: 84,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.18,67.42a19.93,19.93,0,0,0-22.36,0c-.53.36-1,.74-1.54,1.15a19.28,19.28,0,0,0-2.71,2.71,20,20,0,0,0,0,25.44,19.28,19.28,0,0,0,2.71,2.71c.49.41,1,.79,1.54,1.15A20,20,0,1,0,87.18,67.42ZM76,102A18,18,0,1,1,94,84,18,18,0,0,1,76,102Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 76,
    cy: 92.5,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.5,
    y: 73.5,
    width: 3,
    height: 14,
    rx: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamlError);
export default __webpack_public_path__ + "static/media/saml-error.3645e156d00d9c127d47975d4f3ae023.svg";
export { ForwardRef as ReactComponent };